import { useUserProgression } from "@/conversation/sidebar/UserProgression/UserProgressionContext";
import { useCuraiVisitRedirect } from "@/hooks/useCuraiVisitRedirect";
import CuraiConsentScreen from "./CuraiConsentScreen";
import VisitBlockedByMergeNotice from "./VisitBlockedByMergeNotice";

type CuraiConsentRedirectProps = {
  conversationId: string;
  clinicRequestId?: string;
  resume?: boolean;
};

const CuraiConsentRedirect = ({
  conversationId,
  clinicRequestId,
  resume = false,
}: CuraiConsentRedirectProps) => {
  const userProgressionContext = useUserProgression();
  const { startVisit, isLoading, isPending, isBlockedByMerge } =
    useCuraiVisitRedirect({
      conversationId,
      clinicRequestId,
      userProgressionId: userProgressionContext?.progression.id,
      resume,
    });

  if (isBlockedByMerge) {
    return <VisitBlockedByMergeNotice />;
  }

  return (
    <CuraiConsentScreen
      onContinue={startVisit}
      isSubmitting={isPending}
      loading={isLoading || isPending}
    />
  );
};

export default CuraiConsentRedirect;
